import { ICartProductData } from 'cart'
import { Translate } from 'common'
import { ProductLocationModel, ProductModel } from 'interfaces'
import { StoreInstances } from 'src/store/StoreInstancesContainer'
import { translateApiScheduleText } from 'src/helpers/utils'

interface Response {
  onInputTooltipMsg: string
  shouldShowLocationSelector: () => Promise<void>
}

export const useQuantitySelectorToolbox = (
  cartProduct: ICartProductData,
  locationOverride?: ProductLocationModel
): Response => {
  const {
    product,
    activeLocation,
    getInCartQtyByLocation,
    showLocationSelector,
  } = cartProduct

  const locationHasParts = (l: ProductLocationModel) =>
    getInCartQtyByLocation(l) > 0

  const isPartAtMultipleLocations = (product: ProductModel): boolean => {
    const locations: ProductLocationModel[] = product?.location || []
    const locationsWithParts = locations.filter(locationHasParts)
    return locationsWithParts?.length > 1
  }

  /**
   * If true then shows the location selector and interrupts the flow
   * @returns Promise
   */
  const shouldShowLocationSelector = async (): Promise<void> => {
    const partInMultipleLocations = isPartAtMultipleLocations(product)

    if (
      StoreInstances.uiStore.isMultiLocationEnabled() &&
      partInMultipleLocations
    ) {
      showLocationSelector()
      return Promise.reject()
    }

    return Promise.resolve()
  }

  const getInputTooltipMessage = (location: ProductLocationModel): string => {
    const partInMultipleLocations = isPartAtMultipleLocations(product)
    if (partInMultipleLocations)
      return Translate('itemAddedFromMultipleLocationsTooltipDisclaimer')
    return translateApiScheduleText(location?.schedule)
  }

  const locationForTooltip = locationOverride ?? activeLocation
  const onInputTooltipMsg =
    getInputTooltipMessage(locationForTooltip)?.trim() ?? ''

  return { onInputTooltipMsg, shouldShowLocationSelector }
}
